/**
 * @generated SignedSource<<937d1bc5123ffe6dc4095ff0b9177838>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type RenameNovaAgentVersionInput = {
  id: string;
  versionNumber: number;
  versionName: string;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type RenameNovaAgentVersionMutation$variables = {
  input: RenameNovaAgentVersionInput;
};
export type RenameNovaAgentVersionMutation$data = {
  readonly renameNovaAgentVersion: {
    readonly agent: {
      readonly id: string;
      readonly versions: ReadonlyArray<{
        readonly versionNumber: number;
        readonly contentHash: string | null;
      }>;
    } | null;
  } | null;
};
export type RenameNovaAgentVersionMutation = {
  variables: RenameNovaAgentVersionMutation$variables;
  response: RenameNovaAgentVersionMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "RenameNovaAgentVersionPayload",
    "kind": "LinkedField",
    "name": "renameNovaAgentVersion",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NovaAgent",
        "kind": "LinkedField",
        "name": "agent",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "NovaAgentVersion",
            "kind": "LinkedField",
            "name": "versions",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "versionNumber",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "contentHash",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RenameNovaAgentVersionMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RenameNovaAgentVersionMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "5d9211eaf4035f4e6f03cc13e1e770f9",
    "id": null,
    "metadata": {},
    "name": "RenameNovaAgentVersionMutation",
    "operationKind": "mutation",
    "text": "mutation RenameNovaAgentVersionMutation(\n  $input: RenameNovaAgentVersionInput!\n) {\n  renameNovaAgentVersion(input: $input) {\n    agent {\n      id\n      versions {\n        versionNumber\n        contentHash\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "4460f24fc07b77ff425600ad23b76a2c";

export default node;
